export const NEWSLETTER_TERMS_URL =
    'https://help.spacenk.com/hc/en-us/articles/360000930633-Terms-Conditions-for-Online-Sales';

export const NEWSLETTER_PRIVACY_URL = 'https://help.spacenk.com/hc/en-us/articles/115003880965-Privacy-Policy';

export const NEWSLETTER_COOKIE_POLICY_URL = 'https://www.spacenk.com/uk/cookie-policy.html';

export const externalLinkClassName = 'underline underline-offset-2 hover:opacity-90';
